import { render, staticRenderFns } from "./fixedBtn.vue?vue&type=template&id=62cb5c76&scoped=true"
import script from "./fixedBtn.vue?vue&type=script&lang=js"
export * from "./fixedBtn.vue?vue&type=script&lang=js"
import style0 from "./fixedBtn.vue?vue&type=style&index=0&id=62cb5c76&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cb5c76",
  null
  
)

export default component.exports